import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  AccordionItem,
  AccordionItemHeader,
  AccordionItemPanel,
} from 'src/components/common/Accordion';
import type { FilterSections } from 'src/components/followUp/FilterColumn/FilterColumn';
import FilterColumn from 'src/components/followUp/FilterColumn/FilterColumn';

interface TicketFilterProps {
  itemName: string;
  filterColumnSections?: FilterSections;
}

const TicketFilter: FC<TicketFilterProps> = ({
  itemName,
  filterColumnSections,
}) => {
  const { t } = useTranslation('followUp');
  return (
    <AccordionItem itemName={itemName}>
      <AccordionItemHeader
        headline={t('filter.ticketFilter')}
        showSelectedFilterCountForKey={[
          t('tableHeader.status'),
          t('tableHeader.npsGroup'),
          t('tableHeader.followUpOwner'),
        ]}
      />
      <AccordionItemPanel>
        <FilterColumn {...filterColumnSections} />
      </AccordionItemPanel>
    </AccordionItem>
  );
};

export default TicketFilter;
